import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

function ManagerRoute() {

  const { currentStaff } = useSelector((state) => state.staff);

  return (
    currentStaff && currentStaff.position === "manager" ? 
      ( <Outlet /> ) :
      (<Navigate to={'/sign-in'} />)
  );
};

export default ManagerRoute;